<template>
    <div class="organization-selector-vselect">
        <v-select
            v-if="isVisible && isEditing"
            ref="select"
            :value="organization"
            :options="organizations"
            :clearable="false"
            :searchable="true"
            :filterable="true"
            :append-to-body="false"
            label="title"
            class="navbar-organization-select"
            @input="onSelect"
            @close="exitEditMode"
            @search:blur="exitEditMode"
        >
            <template #selected-option="option">
                <span class="text-body">{{ option.title }}</span>
            </template>
            <template #option="option">
                <span>{{ option.title }}</span>
            </template>
        </v-select>
        <button
            v-else-if="isVisible"
            type="button"
            class="organization-selector-trigger ml-50 text-body"
            @click="enterEditMode"
        >
            <TextEllipsis
                :value="organization.title"
                :max-length="28"
            />
        </button>
        <span
            v-else
            class="ml-50 text-body organization-selector-title"
        >
            <TextEllipsis
                :value="organization.title"
                :max-length="28"
            />
        </span>
    </div>
</template>

<script>
import TextEllipsis from '@core/components/common/TextEllipsis.vue'
import vSelect from 'vue-select'

export default {
    name: 'OrganizationSelectorVSelect',
    components: {
        TextEllipsis,
        vSelect,
    },
    data() {
        return {
            isEditing: false,
        }
    },
    computed: {
        organization() {
            return this.$store.state.user.organization
        },
        organizations() {
            return this.$store.state.user.organizations
        },
        isVisible() {
            return this.organizations.length > 1
        },
    },
    methods: {
        enterEditMode() {
            this.isEditing = true
            this.$nextTick(() => {
                const { select } = this.$refs
                if (!select) {
                    return
                }

                if (typeof select.focus === 'function') {
                    select.focus()
                }

                const { searchEl } = select
                if (searchEl && typeof searchEl.focus === 'function') {
                    searchEl.focus()
                }

                select.open = true
            })
        },
        exitEditMode() {
            this.isEditing = false
        },
        onSelect(organization) {
            this.exitEditMode()

            if (!organization || organization.id === this.organization.id) {
                return
            }

            this.$store.dispatch('selectOrganization', organization).then(() => {
                if (this.$router.currentRoute.name !== 'homepage') {
                    this.$router.replace('/homepage')
                }
            })
        },
    },
}
</script>

<style lang="scss">
.organization-selector-vselect {
    .organization-selector-trigger {
        padding: 0;
        border: 0;
        background: transparent;
        cursor: pointer;
        color: #fff !important;
    }

    .organization-selector-title {
        color: #fff !important;
    }

    .navbar-organization-select.v-select {
        width: auto;
        min-width: 240px;
    }

    .navbar-organization-select .vs__dropdown-toggle {
        min-height: 38px;
        border: 1px solid rgba(255, 255, 255, 0.18);
        background-color: rgba(255, 255, 255, 0.08);
    }

    .navbar-organization-select .vs__selected,
    .navbar-organization-select .vs__search,
    .navbar-organization-select .vs__actions,
    .navbar-organization-select .vs__open-indicator,
    .navbar-organization-select .vs__clear {
        color: #fff;
        fill: #fff;
    }

    .navbar-organization-select .vs__search::placeholder {
        color: rgba(255, 255, 255, 0.7);
    }

    .navbar-organization-select .vs__dropdown-menu {
        max-height: 320px;
        overflow-y: auto;
    }
}
</style>
